/*
 * 抱怨列表页面
 */
<template>
  <div class="common-container">
    <v-navigation-drawer class="my-3 drawer-fix"
                         floating
                         permanent>
      <v-list class="d-flex pa-0">
        <template v-for="item in items">
          <v-list-tile :key="item.title"
                        class="tabs-route"
                       :class="(item.tile === paths) ? 'tab-route-active' : ''"
                       @click="turnPage(item)">
            <v-list-tile-content>
              <v-list-tile-title >{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      // {
      //   title: 'Complaint Records',
      //   tile: 'complaintRecords',
      //   icon: 'create'
      // },
      {
        title: 'Received Complaint',
        tile: 'receivedComplaint',
        icon: 'sentiment_dissatisfied'
      },
      {
        title: 'Late and leave early',
        tile: 'lateAttendanceEarlyLeave',
        icon: 'alarm_off'
      }
    ]
  }),
  computed: {
    paths: function () {
      return this.$route.fullPath.split('/').pop()
    }
  },
  methods: {
    turnPage (e) {
      this.$router.push({ path: `/complaintList/${e.tile}` })
    }
  }
}
</script>
<style lang="sass" scoped>
  // @import "./complaintList"
</style>

